// src/components/MaintenanceScreen.js
import React, { useEffect } from 'react';
import { Card, CardBody, LayoutContainer, MessageBlock } from './ui';
import '../styles/infrastructureScreens.css';

const MaintenanceScreen = () => {
  const normalizeNewlines = (text) => (text || '').replace(/\\n/g, '\n');

  const title = process.env.REACT_APP_MAINTENANCE_TITLE || 'Sistema en Mantenimiento';
  const message = normalizeNewlines(
    process.env.REACT_APP_MAINTENANCE_MESSAGE ||
    'Estamos realizando mejoras en nuestro sistema.\\nVolveremos pronto con nuevas funcionalidades.'
  );
  const contact = normalizeNewlines(
    process.env.REACT_APP_MAINTENANCE_CONTACT ||
    'Para consultas urgentes, contacta al equipo de soporte tecnico.'
  );

  useEffect(() => {
    const appStyle = document.createElement('link');
    appStyle.rel = 'stylesheet';
    appStyle.href = `${process.env.PUBLIC_URL}/assets/css/app.css`;
    document.head.appendChild(appStyle);

    const authStyle = document.createElement('link');
    authStyle.rel = 'stylesheet';
    authStyle.href = `${process.env.PUBLIC_URL}/assets/css/auth.css`;
    document.head.appendChild(authStyle);

    return () => {
      if (document.head.contains(appStyle)) {
        document.head.removeChild(appStyle);
      }
      if (document.head.contains(authStyle)) {
        document.head.removeChild(authStyle);
      }
    };
  }, []);

  return (
    <div id="auth" className="rg-maintenance">
      <div className="row h-100">
        <div className="col-lg-5 col-12">
          <div id="auth-left" className="rg-maintenance__left">
            <LayoutContainer size="md" className="rg-maintenance__container">
              <div className="auth-logo rg-maintenance__logo">
                <img
                  src={process.env.REACT_APP_CLIENT_LOGO || '/assets/images/cirenio.svg'}
                  alt="Client Logo"
                />
              </div>

              <Card className="rg-maintenance__card rg-elevation-2">
                <CardBody className="rg-maintenance__card-body">
                  <div className="rg-maintenance__icon-wrap" aria-hidden="true">
                    <div className="rg-maintenance__icon-pulse">
                      <i className="bi bi-tools rg-maintenance__icon"></i>
                    </div>
                  </div>

                  <h1 className="auth-title rg-maintenance__title">{title}</h1>

                  <div className="rg-maintenance__message">
                    {message.split('\n').map((line, index) => (
                      <p key={index} className="auth-subtitle rg-maintenance__message-line">
                        {line}
                      </p>
                    ))}
                  </div>

                  {contact && (
                    <MessageBlock tone="info" title="Soporte" className="rg-maintenance__support">
                      {contact.split('\n').join(' ')}
                    </MessageBlock>
                  )}

                  <div className="rg-maintenance__thanks">
                    <small>Gracias por tu paciencia</small>
                  </div>
                </CardBody>
              </Card>
            </LayoutContainer>
          </div>
        </div>

        <div className="col-lg-7 d-none d-lg-block">
          <div id="auth-right">
            <img src="/assets/images/logo-cirenio-white.svg" alt="Cirenio Logo" className="cirenio-logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
